import { useEffect, useRef, useState } from "react";

export default function PreCheckCamera({ onReady }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const intervalRef = useRef(null);
  const PROCTOR_API = process.env.REACT_APP_PROCTOR_API_URL;

  const [message, setMessage] = useState("Checking face...");

  useEffect(() => {
    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        streamRef.current = stream;

        if (!videoRef.current) return;

        videoRef.current.srcObject = stream;

        // ✅ SAFE PLAY
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play().catch(() => {});
        };

        // 🔁 Face check loop
        intervalRef.current = setInterval(async () => {
          if (!videoRef.current || !canvasRef.current) return;

          const ctx = canvasRef.current.getContext("2d");
          ctx.drawImage(videoRef.current, 0, 0, 320, 240);

          const image = canvasRef.current.toDataURL("image/jpeg");

          const res = await fetch(`${PROCTOR_API}/analyze`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ image }),
          });

          const data = await res.json();

          if (data.faces === 1) {
            setMessage("✅ Face detected. You may start the test.");
            onReady(true);
          } else {
            setMessage("❌ Please keep your face clearly visible.");
            onReady(false);
          }
        }, 1000);
      } catch (err) {
        console.error("Camera error:", err);
        setMessage("❌ Camera access failed");
        onReady(false);
      }
    };

    startCamera();

    // 🧹 CLEANUP (VERY IMPORTANT)
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);

      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
    };
  }, [onReady]);

  return (
    <div className="text-center">
      <video
        ref={videoRef}
        muted
        playsInline
        className="mx-auto rounded"
      />
      <canvas
        ref={canvasRef}
        width={320}
        height={240}
        className="hidden"
      />
      <p className="mt-2 text-sm font-semibold">{message}</p>
    </div>
  );
}
